import script from "./QuestionListDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionListDetail.vue?vue&type=script&setup=true&lang=js"

import "./QuestionListDetail.vue?vue&type=style&index=0&id=4cb3f870&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cb3f870"]])

export default __exports__